module.exports = __webpack_public_path__ + "media/images/div_lens/inclusive-mobile-img1-9d33ada5c251da0170c9146d3713c1b4.jpg";